import styled from "styled-components";
import {Button} from "antd";
export const CreateCampaignButton = styled(Button)`
    @media screen and (max-width: 768px) {
        width: 100%;
        margin: 8px 0;
    }
`;
